import React, { useState } from 'react';
import { BlobServiceClient } from '@azure/storage-blob';
import { Button, Box,Typography} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

export function FileUpload(){
  const sasToken = "?sv=2022-11-02&ss=bfqt&srt=o&sp=rwdlacupiytfx&se=2025-12-23T12:19:02Z&st=2024-12-24T04:19:02Z&spr=https&sig=CDCMyWFXZSo2oP0YYvnX6ajQt9pTDb1dCh2N7R0Fwi0%3D"; // Fill string with your SAS token
  const containerName = `newcontainer`;
  const storageAccountName = "storage11012022"; // Fill string with your Storage resource name
  
  const uploadFileToBlob = async (file) => {
    if (!file) return [];
  
    // get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
    const blobService = new BlobServiceClient(
      `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
    );
    // get Container - full public read access
    const containerClient = blobService.getContainerClient(containerName);
  
    // create blobClient for container
    const blobClient = containerClient.getBlockBlobClient(file.name);
  
    // set mimetype as determined from browser with file upload control
    const options = { blobHTTPHeaders: { blobContentType: file.type } };
  
    // upload file
    await blobClient.uploadData(file, options);
    await blobClient.setMetadata({UserName : 'webcms'});
  
    // simple response
    return "Success";
  };
  // all blobs in container
  //const [blobList, setBlobList] = useState([]);

  // current file to upload into container
  const [fileSelected, setFileSelected] = useState(null);

  // UI/form management
  const [uploading, setUploading] = useState(false);
  const [inputKey, setInputKey] = useState(Math.random().toString(36));

  const onFileChange = (event) => {
    // capture file into state
    setFileSelected(event.target.files[0]);
    console.log(event.target.files[0]);
  };


  const onFileUpload = async () => {
    // prepare UI
    setUploading(true);

    // *** UPLOAD TO AZURE STORAGE ***
    const resp = await uploadFileToBlob(fileSelected);

    // console log results
    console.log(resp);

    // reset state/form
    setFileSelected(null);
    setUploading(false);
    setInputKey(Math.random().toString(36));
  };

  // display form
  const DisplayForm = () => (
      <Box component="form" 
        onSubmit={onFileUpload} 
        display="flex" 
        flexDirection="column" 
        alignItems="center" 
        p={4}>
      <h1>Upload to Azure Storage</h1>
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <input
          type="file"
          key={inputKey || ''}
          onChange={onFileChange}
          style={{ display: 'none' }}
          id="file-input"
        />
        <label htmlFor="file-input">
          <Button
            variant="contained"
            color="primary"
            component="span"
            startIcon={<CloudUploadIcon />}
          >
            Choose File
          </Button>
        </label>
        {fileSelected && <Typography>{fileSelected.name}</Typography>}
        <Box sx={{ display: 'none'}}>
          <input type="text" 
          value={fileSelected==null?'':fileSelected.name} 
          />
        </Box>
      </Box>
      <Button 
      type="submit"
      color="primary"
      variant="contained"
      disabled={!fileSelected}       
      sx={{ mt: 3 }}>
        Upload!
      </Button>
    </Box>
  );

  return (
    <div>
      <hr />    
      {!uploading && DisplayForm()}
      {uploading && <div>Uploading</div>}

    </div>
  );
};

